import { Golden, H1 } from "@motley/design"
import { TenantCreateForm } from "@/tenant"

export default function OnboardingPage() {
  return (
    <Golden className="h-screen">
      <H1>Name your workspace</H1>
      <div className="m-4 w-sm">
        <TenantCreateForm />
      </div>
    </Golden>
  )
}
